import { getStore } from "../configureStore";

export const getShop = () => getStore().getState().shop;
